import * as React from "react";
import { useState, useRef } from "react";
import { Workflow } from "../types";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../types";
import { Organization } from "../../organizations/types";
import { post } from "../../../utils/fetch";
import useOnClickOutside from "../../../utils/useOnClickOutside";
import { WaitingRoomAppointmentBatchResponse } from "../types";
import sample from "../../../../public/appointments-sample.csv";
import flash from "../../flash/actions";

type Props = {
  selectedWorkflow?: Workflow | null;
  setLoading: (isLoading: boolean) => void;
};

const UploadAppointments: React.FunctionComponent<Props> = ({
  selectedWorkflow,
  setLoading
}: Props) => {
  const [showMenu, setShowMenu] = useState<boolean>(false);
  const dropdownMenu = useRef();
  useOnClickOutside(dropdownMenu, () => setShowMenu(false));

  const currentOrganization: Organization | null = useSelector(
    (state: RootState) => state.orgs.currentOrganization
  );

  const toggleShowMenu = () => {
    setShowMenu(!showMenu);
  };

  const dispatch = useDispatch();

  const onFileChangeHandler = async (event: any) => {
    setLoading(true);
    const formData = new FormData();
    formData.append("related_objects", event.target.files[0]);
    const url = `/api/organization/${currentOrganization?.id}/workflows/${selectedWorkflow?.id}/appointments/appointmentUpload/`;
    const resp = await post<WaitingRoomAppointmentBatchResponse>(url, formData);
    if (resp && resp.status === 201 && resp.data) {
      dispatch(
        flash(
          `${resp.data.processedCount} out of ${resp.data.recordCount} total records processed`,
          resp.data.status === "processed" ? "info" : "error"
        )
      );
    } else {
      const errMsg = Object.values(resp.error?.fieldErrors).join(", ");
      dispatch(flash(`There was a problem processing your file: ${errMsg}`, "error"));
    }
    setLoading(false);
    setShowMenu(false);
  };

  return (
    <div className="add-patient-apt-container" ref={dropdownMenu}>
      <button onClick={toggleShowMenu} className={showMenu ? "selected" : ""}>
        <i className="far fa-cloud-upload btn-icon" /> Upload Appointments
      </button>

      {showMenu && (
        <div className="dialog-menu">
          <div className="dialog-content">
            <div className="bold">You can upload a file to import many appointments.</div>
            <div className="mt-10 mb-20">
              Please use the sample file below to create your upload file.
            </div>
            <div className="mt-10 mb-20">
              <a href={sample} className="hyperlink" download="sample.csv">
                Download a sample file
              </a>
            </div>
            <div className="flex-end mt-15">
              <input type="file" name="related_objects" onChange={onFileChangeHandler} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UploadAppointments;
